/*eslint-disable */
var $ = window.jQuery = require('jquery')
import carousel from 'vue-owl-carousel'
export default {
  name: 'vista-linkage-screen',
  components: {
    carousel
  },
  props: [],
  data () {
    return {
      popularVideosData:null,
      popularVideosResults:[]
    }
  },
  computed: {
  },
  mounted () {
  this.$store.dispatch('vistaPublicMediaListFun').then((res) => {
    this.popularVideosData = res.data
    this.popularVideosResults = this.popularVideosData.data
  })
  },
  methods: {
  },
  watch:{
  },
}